import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { FiX } from "@react-icons/all-files/fi/FiX";
import { FiHeart } from "@react-icons/all-files/fi/FiHeart";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import InstagramEmbed from "../InstagramEmbed/InstagramEmbed";
import "./_style.scss";
const FOCUSABLE_SELECTOR = "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])";
function FeaturedByModal({ featuredByLink, onClose, paymentUrl }) {
    const { translate: t } = useLanguageProvider();
    const isInstagram = featuredByLink.linkType === "Instagram";
    const containerRef = useRef(null);
    const closeButtonRef = useRef(null);
    const triggerElementRef = useRef(null);
    // Captures whatever triggered the modal (the featured-by card) before moving focus into the
    // dialog, then restores it on unmount so keyboard/screen-reader users land back where they were.
    useEffect(() => {
        var _a;
        triggerElementRef.current = document.activeElement;
        (_a = closeButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        return () => {
            var _a;
            (_a = triggerElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        };
    }, []);
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose();
                return;
            }
            if (e.key === "Tab" && containerRef.current) {
                const focusable = containerRef.current.querySelectorAll(FOCUSABLE_SELECTOR);
                if (focusable.length === 0) {
                    return;
                }
                const first = focusable[0];
                const last = focusable[focusable.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
                else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);
    useEffect(() => {
        const previous = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = previous;
        };
    }, []);
    return (_jsx("div", { className: "featured-by-modal__overlay", role: "dialog", "aria-modal": "true", "aria-label": t("Featured by"), children: _jsxs("div", { className: "featured-by-modal__container", ref: containerRef, children: [_jsx("div", { className: "featured-by-modal__header", children: _jsx("button", { type: "button", ref: closeButtonRef, className: "featured-by-modal__close-btn", onClick: onClose, "aria-label": t("Close"), children: _jsx(FiX, {}) }) }), _jsx("div", { className: `featured-by-modal__body${isInstagram ? " --instagram" : ""}`, children: isInstagram ? (_jsx(InstagramEmbed, { url: featuredByLink.url })) : (_jsx("a", { className: "featured-by-modal__fallback-link", href: featuredByLink.url, target: "_blank", rel: "noopener noreferrer", children: featuredByLink.url })) }), _jsx("div", { className: "featured-by-modal__footer", children: _jsxs("a", { href: paymentUrl, className: "featured-by-modal__donate-btn", children: [_jsx(FiHeart, {}), t("Donate now")] }) })] }) }));
}
export default FeaturedByModal;
